var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"goods-jump",attrs:{"href":"javascript:"},on:{"click":_vm.goodsTap}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }